// CareersPage.js - /src/pages/CareersPage.js
import React from 'react';
import { Link } from 'react-router-dom';

// CareersPage.js - /src/pages/CareersPage.js
const CareersPage = () => (
  <div style={{ backgroundColor: '#0a0a0a', color: 'white', minHeight: '100vh', padding: '4rem 2rem' }}>
    <nav style={{ marginBottom: '4rem', textAlign: 'center' }}>
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
        <span style={{ fontSize: '1.5rem' }}>🕵🏽</span>
        <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#e07a5f' }}>WhyDidItDie</span>
      </Link>
    </nav>
    <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
      <h1 style={{ fontSize: '3rem', marginBottom: '2rem', color: '#e07a5f' }}>Careers</h1>
      <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>Join us in building the future of marketing intelligence!</p>
      <Link to="/homepage" style={{ color: '#e07a5f', textDecoration: 'none', fontSize: '1.1rem' }}>← Back to Home</Link>
    </div>
  </div>
);

export default CareersPage;